import { del, get, post, put } from "../api"
import * as url from "./urls"

const getFilters = () => {
  return get(url.GET_FILTERS)
}

export { getFilters }
